'use strict';
const angular = require('angular');

//Variables
var page = {}; //Set initial page title for logged in view
var breadcrumb = [];

// Main Nav 
// Sidebar Nav
/**
 * Sidebar Nav
 * @title = Visible link title
 * @url = href link
 * @dropdown = true/false. whether nav item is a dropdown list
 * @navLinkIconClass = set style for navigation link icon
 * @subItem1 = dropdown items in case of dropdown menu
 * @subItem1 @active = true/false whether link is active
 */

var sideBarNav = [
  {
    title: 'Dashboard',
    url: '/account/dashboard',
    dropdown: false,
    navLinkIconClass: 'nav-link--dashboard',
    show: 'loggedIn',
  },
  /**
   * todo: Uncomment when adding admin functions and modules
   */
  {
    title: 'Compliance',
    url: '/account/compliance',
    dropdown: true,
    navLinkIconClass: 'nav-link--compliance',
    show: 'loggedIn',
    role: 'Administrator',
    subItem1: [
      {
        title: 'Submissions',
        url: '/account/compliance/submissions'
      },
      {
        title: 'Jurisdictions',
        url: '/account/compliance/jurisdictions'
      },{
        title: 'Station Areas',
        url: '/account/compliance/stationareas'
      }
    ]
  },
  {
    title: 'TOC Policy',
    url: '/account/toc_policy',
    dropdown: false,
    navLinkIconClass: 'nav-link--policy',
    show: 'loggedIn',
    // subItem1: [
    //   {
    //     title: 'Documents',
    //     url: '/account/toc_policy/documents'
    //   }
    // ]
  },
  {
    title: 'Density',
    url: '/account/density',
    dropdown: true,
    navLinkIconClass: 'nav-link--density',
    show: 'loggedIn',
    subItem1: [
      // {
      //   title: 'Density Compliance',
      //   url: '/account/density/density_compliance'
      // },
      // {
      //   title: 'Density Requirements',
      //   url: '/account/density/density_requirements'
      // },
      {
        title: 'Density for Residential Uses',
        url: '/account/density/residential_uses'
      },
      {
        title: 'Intensity for Commercial Office Uses',
        url: '/account/density/commercial_uses',
        active: false
      },
    ]
  },
  {
    title: 'Affordable Housing',
    url: '/account/housing',
    dropdown: true,
    navLinkIconClass: 'nav-link--housing',
    show: 'loggedIn',
    subItem1: [
      {
        title: 'Affordable Housing Production',
        url: '/account/housing/housing_production'
      },
      {
        title: 'Affordable Housing Preservation',
        url: '/account/housing/housing_preservation',
      },
      {
        title: 'Affordable Housing Protection',
        url: '/account/housing/housing_protection'
      },
      {
        title: 'Commercial Stabilization',
        url: '/account/housing/commercial_stabilization'
      }
    ]
  },
  {
    title: 'Parking',
    url: '/account/parking',
    dropdown: true,
    navLinkIconClass: 'nav-link--parking',
    show: 'loggedIn',
    subItem1: [
      {
        title: 'Vehicle Parking',
        url: '/account/parking/vehicle_parking'
      },
      {
        title: 'Bicycle Parking',
        url: '/account/parking/bicycle_parking'
      },
      {
        title: 'Parking Policies',
        url: '/account/parking/parking_policies'
      }
    ]
  },
  {
    title: 'Station Access',
    url: '/account/stationaccess',
    dropdown: true,
    navLinkIconClass: 'nav-link--station',
    show: 'loggedIn',
    subItem1: [
      // {
      //   title: 'Summary of Requirements',
      //   url: '/account/stationaccess/station_requirements',
      // },
      {
        title: 'Complete Streets and Active Transportation',
        url: '/account/stationaccess/complete_streets',
      },
      {
        title: 'Project Prioritization and Implementation',
        url: '/account/stationaccess/project_prioritization',
      },
      {
        title: 'Access Gap Analysis',
        url: '/account/stationaccess/analysis_improvement_program',
      },
      {
        title: 'Mobility Hub Planning and Implementation',
        url: '/account/stationaccess/mobility_hub',
      }
    ]
  },
  {
    title: 'Map',
    url: '/account/map',
    dropdown: false,
    navLinkIconClass: 'nav-link--map',
    show: 'loggedIn'
  },
];
/*@ngInject*/
export function navServiceService() {
	 //Get Sidebar Nav
   this.getSideBarNav = function () {
    return sideBarNav;
  };

  this.getPage = function() {
    return page;
  }

  this.setPage = function(page) {
    page = page;
  }

  this.getBreadCrumb = function(){
    return breadcrumb;
  }

  this.setBreadCrumb = function(page, subItem1, subItem2) {
    breadcrumb = [];
    if(page){
      breadcrumb.push({
        linkTitle: page.title,
        link1: page.url
      })
    }

    if(subItem1){
      breadcrumb.push({
        linkTitle1: subItem1.title,
        link: subItem1.url
      })
    } 
    if(subItem2){
      breadcrumb.push({
        linkTitle2: subItem2.title,
        link: subItem2.url
      })
    }
  }
  

}

export default angular.module('appApp.navService', [])
  .service('navService', navServiceService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/navService/navService.service.js